import MenuSection from "../../components/Menu/MenuSection";
import PropTypes from "prop-types";
import React from "react";
import { SurveyMenuItem } from "./SurveyMenuItem";
import { UserContextSelectors } from "../../redux/selectors";
import { useSelector } from "react-redux";
import { BrandUtils } from "../../utils/brandUtils";
import { loadHomeSection } from "./loader";
import {
  CasinoDailyWishChunk,
  useIsCasinoDailyWishAvailable
} from "./CasinoDailyWish";
import { PageContextUtils } from "../../utils";

const getHomeSection = (brandId, componentProps = {}) => {
  if (Number.isNaN(Number(brandId))) return null;

  const { name } = PageContextUtils.getClientProviderData();

  const HomeSection = loadHomeSection(brandId, name);

  return <HomeSection {...componentProps} />;
};

const Home = ({ trackingInfo }) => {
  const brandId = useSelector(UserContextSelectors.brandId);
  const isCasinoDailyWishAvailable = useIsCasinoDailyWishAvailable();

  return (
    <MenuSection className="homeSection">
      {getHomeSection(brandId, {
        trackingInfo
      })}
      {/* will be returned in the future */}
      {BrandUtils.isPokerClient() !== true && (
        <SurveyMenuItem trackingInfo={trackingInfo} />
      )}

      {isCasinoDailyWishAvailable && (
        <CasinoDailyWishChunk trackingInfo={trackingInfo} />
      )}
    </MenuSection>
  );
};

Home.propTypes = {
  trackingInfo: PropTypes.object
};

export default React.memo(Home);

export * from "./SurveyMenuItem";
